import { appConfig } from 'config/environment/appConfig'

import { FileUploadRequest } from 'services/FileService'
import { HttpService } from 'services/HttpService'
import convertKeysToCamelCase from 'utils/helpers/convertKeysToCamelCase'
import { ResponseListData } from 'shared/types/types'

import {
  CreateSupportLogRequest,
  CreateTicketRequest,
  GetTicketListRequest,
  RateTicketRequest,
  TicketDTO,
  TicketFileUploadDTO,
  TicketStatus,
} from './types'

const ticketsService = new HttpService(appConfig.TICKETS_URL)

export const ticketApi = {
  createTicket: async (data: CreateTicketRequest): Promise<{ ticketId: number }> => {
    const result = await ticketsService.post('/api/v1/user/tickets', {
      body: {
        ticket_type_id: data.ticketType,
        ticket_reason_id: data.ticketReason,
        description: data.description,
        files: data.files,
        id_order: data.orderId,
      },
    })

    return convertKeysToCamelCase(result)
  },

  ticketFileUpload: async (data: FileUploadRequest): Promise<TicketFileUploadDTO> => {
    const result = await ticketsService.post('api/v2/common/upload', {
      body: {
        chunk_num: data.chunkNum,
        entity_type: data.entityType,
        total_size: data.totalSize,
        chunk: data.chunk,
        uuid: data.uuid,
      },
    })

    return convertKeysToCamelCase(result)
  },

  getTicketList: async (data: GetTicketListRequest): Promise<ResponseListData<TicketDTO[]>> => {
    const result = await ticketsService.post<ResponseListData<TicketDTO[]>>('api/v3/user/tickets/all', {
      body: {
        offset: data.page * data.pageSize - data.pageSize,
        limit: data.pageSize,
        search: data.search,
        ticketStateId: data.ticketStateId,
        sort_by_create_date: data.sortByCreateDate,
        ticket_type_ids: data.ticketTypeIds,
        only_my_tickets: true,
      },
    })

    return convertKeysToCamelCase(result)
  },

  createSupportLog: async (data: CreateSupportLogRequest) => {
    return await ticketsService.post('api/v1/user/support-log', {
      body: {
        ticket_id: data.ticketId,
        message: data.message,
        document_urls: data.files?.document_urls,
        image_urls: data.files?.image_urls,
        video_urls: data.files?.video_urls,
      },
    })
  },

  closeTicket: async (ticketId: number) => {
    return await ticketsService.post('api/v1/user/tickets/set-state', {
      body: {
        ticket_id: ticketId,
        ticket_state_id: TicketStatus.closed,
      },
    })
  },

  rateTicket: async ({ ticketId, grade, message }: RateTicketRequest) => {
    return await ticketsService.post('api/v1/user/grade', {
      body: {
        ticket_id: ticketId,
        grade,
        message,
      },
    })
  },
}
